import React, { useState } from "react";
import loadable from "@loadable/component";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import useGetHook from "../../customHooks/useGetHook";
import { useSearchParams } from "react-router-dom";
const CreatePickupRequestComponent = loadable(
  () =>
    import("../../Components/CourierPickupRequest/CreateCourierPickupRequest")
);
const CreateCourierPickupRequest = () => {
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);
  const [searchParams, setSearchParms] = useSearchParams();
  const selectedOrder = searchParams.get("selectedItems")?.split(",");
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["pickup-request"],
    navigateURL: "/",
  });

  const { data: gridData, isLoading: isStatusDataLoading } = useGetHook({
    queryKey: [`runsheet-status`],
    url: `${APIS.PICKUPREQUEST_STATUS}`,
    params: {},
  });

  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
    };
    try {
      const res = await addDriver({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddDriverPopup(!openAddDriverPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,
      insurance_company_contact_number: values?.insurance_company_contact_number
        ? values?.insurance_company_contact_number.startsWith("+977")
          ? values?.insurance_company_contact_number
          : `+977${values?.insurance_company_contact_number}`
        : null,
      samiti_contact_number: values?.samiti_contact_number
        ? values?.samiti_contact_number.startsWith("+977")
          ? values?.samiti_contact_number
          : `+977${values?.samiti_contact_number}`
        : null,
    };
    try {
      const res = await addVehicle({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddVehiclePopup(!openAddVehiclePopup);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.PICKUPREQUEST;
    const formData = {
      ...values,
      orders: selectedOrder,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Pickup Request
        </span>
      </div>
      <CreatePickupRequestComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
        handleAddVehicle={handleAddVehicle}
        isVehicleLoading={isVehicleLoading}
        handleAddDriver={handleAddDriver}
        isDriverLoading={isDriverLoading}
        openAddVehiclePopup={openAddVehiclePopup}
        setOpenAddVehiclePopup={setOpenAddVehiclePopup}
        openAddDriverPopup={openAddDriverPopup}
        setOpenAddDriverPopup={setOpenAddDriverPopup}
        gridData={gridData}
      />
    </>
  );
};

export default CreateCourierPickupRequest;
